<template>
    <div v-if="firstRendered">
        <div class="filter-condition box-shadow-small border-radius">
            <!--<div class="search-box">-->
                <!--<el-button class="search-hd" type="primary" icon="el-icon-search" @click="searchKeyword(keyword)"></el-button>-->
                <!--<div class="search-bd">-->
                    <!--<search-bar :ajaxSearch="false"  v-model="keyword" @enter-key="searchKeyword" @select="searchKeyword"-->
                                <!--placeholder="请输入职位、姓名、手机号、邮箱进行搜索"></search-bar>-->
                <!--</div>-->
            <!--</div>-->
            <!--<filter-panel @params-change="getParams" ref="condition">-->
                <!--<filter-panel-item v-for="(item, index) in filterConf" :label="item.label" :mode="item.mode"-->
                                   <!--:name="item.name" :data="item.data" :key="index" :visible="item.visible"-->
                                   <!--:initValue="item.value"></filter-panel-item>-->
            <!--</filter-panel>-->
            <multi-search :fields="multiFields"></multi-search>
        </div>
        <div class="filter-result background-white box-shadow-small border-radius">
            <div class="filter-result-header clearfix mt-10">
                <el-row type="flex" justify="space-between">
                    <el-col :span="12">
                        <el-button type="primary" @click="multiProcess('writtenArrangement')">批量笔试安排</el-button>
                        <el-button @click="multiProcess('writtenRecommend')">批量笔试推荐</el-button>
                        <el-button @click="$router.push({name: 'writtenExamList'})">查看笔试安排列表</el-button>
                        <el-button @click="multiRemarkEdit(idStr)">批量编辑备注</el-button>
                        <el-dropdown class="ml-10">
                            <el-button icon="el-icon-my-daochu" type="primary">导出简历<i class="el-icon-caret-bottom el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="exportFiles(idStr, '/arrangeExam')">导出已选记录(excel)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportFiles(idStr, '/arrangeExam', undefined, 'type=HTML')">导出已选记录(html)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportParamsFiles('/arrangeExam/exportAllResume.api')">导出所有查询结果(excel)</el-dropdown-item>
                                <el-dropdown-item @click.native="exportParamsFiles('/arrangeExam/exportAllResume.api', 'HTML')">
                                    导出所有查询结果(html)
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <export-custom-dialog :valid-call-back="customExportValid" :params-call-back="customExportParams"></export-custom-dialog>
                    </el-col>
                    <el-col :span="12">
                        <el-row v-if="lists.length" type="flex" justify="end">
                            <el-button icon="el-icon-my-queding color-success" type="success" :plain="true"
                                       @click="changeStatus(idStr,'pass')">通过
                            </el-button>
                            <el-button icon="el-icon-my-daiding color-warning" type="warning" :plain="true"
                                       @click="changeStatus(idStr,'undetermined')">待定
                            </el-button>
                            <el-button icon="el-icon-my-guanbi color-danger" type="danger" :plain="true"
                                       @click="changeStatus(idStr,'notPass')">淘汰
                            </el-button>
                            <el-button icon="el-icon-my-lahei color-purple" type="purple" :plain="true"
                                       @click="changeStatus(idStr,'lh')">拉黑
                            </el-button>
                            <el-button icon="el-icon-my-huitui color-info" type="info" :plain="true"
                                       @click="changeStatus(idStr,'back')">回退
                            </el-button>
                            <el-button @click="changeStatus(idStr,'fq')" icon="el-icon-my-guanbi color-danger" type="danger" :plain="true">放弃
                            </el-button>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            <div v-loading="partialLoading">
                <empty-tip :show="!lists.length"></empty-tip>
                <div class="table-list mt-20">
                    <el-table v-if="lists.length"
                              :data="lists"
                              @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection"
                                align="center"
                                fixed
                                width="50">
                        </el-table-column>
                        <el-table-column
                                label="姓名"
                                fixed
                                min-width="140">
                            <template slot-scope="scope">
                                <div>
                                    <el-tooltip effect="dark" :content="scope.row.operateReason" placement="top-start" v-if="scope.row.operateReason">
                                        <span>
                                            <status-icon :icon="['not-deal', 'undetermined', 'not-pass', 'lh', 'fq'][scope.row.resumeStatus.substr(2)]"></status-icon><i class="el-icon-my-xinxi"></i>
                                        </span>
                                    </el-tooltip>
                                    <status-icon :icon="['not-deal', 'undetermined', 'not-pass', 'lh', 'fq'][scope.row.resumeStatus.substr(2)]" v-else></status-icon>
                                    <span
                                      class="name-txt eclip-name-txt"
                                      :title="scope.row.name"
                                      @click="toResumeDetail(scope.row)"
                                    >
                                        {{ scope.row.name }}
                                    </span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="gender"
                                label="性别"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="70">
                            <template slot-scope="scope">{{{1: '男', 2: '女'}[scope.row.gender] || '-'}}</template>
                        </el-table-column>
                        <el-table-column
                                label="岗位"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="120">
                            <template slot-scope="scope">
                                {{ scope.row.positionName }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="招聘部门"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{ scope.row.deptNames }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="phone"
                                label="手机号"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="110">
                        </el-table-column>
                        <el-table-column
                                prop="email"
                                label="邮箱"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="110">
                        </el-table-column>
                        <el-table-column
                                prop="degree"
                                label="最高学历"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="90">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_EDU_DEGREE', scope.row.degree) }}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="school"
                                label="最高学历学校"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                        </el-table-column>
                        <el-table-column
                                prop="major"
                                label="专业"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="90">
                        </el-table-column>
                        <el-table-column
                                label="简历来源"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_RESUME_SOURCE', scope.row.resumeSource) || '-'}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="residence"
                                label="当前所在地"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="90">
                        </el-table-column>
                        <el-table-column
                                label="应聘城市"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                {{ getSelectMapText('WB_POSITION_CITY', scope.row.expectCityId)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="positionForm.sourceFrom"
                                label="投递渠道"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scope">
                                {{getSelectMapText('WB_ADD_SOURCE',
                                scope.row.addSource)}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="投递人"
                                prop="addName"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                        </el-table-column>
                        <el-table-column
                                label="推荐人"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="80">
                            <template slot-scope="scope">
                                <span v-if="scope.row.recommender">{{scope.row.recommender.name}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="投递时间" :show-overflow-tooltip="true" min-width="100">
                            <template slot-scope="scope">{{dateFormat(scope.row.commitTime)}}</template>
                        </el-table-column>
                        <el-table-column
                                label='考试场次'
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scoped">
                                <router-link class="exam-name-span" :title="scoped.row.examName" target="_blank" :to="`/written/exam/detail/${scoped.row.examId}`">{{scoped.row.examName}}</router-link>
                                <el-popover v-if="scoped.row.examTimes.length" placement="top"
                                            popper-class="dark-theme popper-line"
                                            trigger="hover">
                                    <div style="width: 220px">
                                        <p>考试时间</p>
                                        <p v-for="(item, index) in scoped.row.examTimes" :key="index">{{item.startTime}}-{{item.endTime.slice(10)}}</p>
                                    </div>
                                    <span slot="reference">
                                        <i class="el-icon-my-xinxi color-primary"></i>
                                    </span>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label='答卷'
                                prop="paperName"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scoped">
                                <template v-if="scoped.row.paperName"><router-link target="_blank" :to="`/written/topic/${scoped.row.paperId}?resumePositionId=${scoped.row.resumePositionId}&examId=${scoped.row.examId}`">{{scoped.row.paperName}}</router-link></template>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label='答卷时间段'
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="100">
                            <template slot-scope="scoped">
                                <template v-if="scoped.row.startTime&&scoped.row.endTime">{{scoped.row.startTime}}-{{scoped.row.endTime.slice(10)}}</template>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="考试状态"
                                :show-overflow-tooltip="true"
                                align="center"
                                min-width="130">
                            <template slot-scope="scope">
                                {{getSelectMapText('WB_RESUME_EXAM_STATUS', scope.row.examStatus)}}
                                <el-popover v-if="scope.row.examStatus" placement="top"
                                            popper-class="dark-theme popper-line text-center tooltip-status-popover"
                                            :value="scope.row.isExamStatusShow"
                                            @mouseenter.native="searchScore(scope.row)"
                                            @mouseleave.native="hideTooltip(scope.row)"
                                            trigger="manual">
                                    <div style="width: 300px">
                                        <span v-if="oneScoreList.length">
                                             <el-row>
                                            <el-col :span="5">评估人</el-col>
                                            <el-col :span="5">评分</el-col>
                                            <el-col :span="5">状态</el-col>
                                            <el-col :span="9">备注</el-col>
                                        </el-row>
                                        <el-row v-for="(item, index) in oneScoreList" :key="index">
                                            <el-col :span="5">{{item.markName}}</el-col>
                                            <el-col :span="5">{{item.score || '-'}}</el-col>
                                            <el-col :span="5">{{item.result || '-'}}</el-col>
                                            <el-col :span="9">{{item.remark || '-'}}</el-col>
                                        </el-row>
                                        </span>
                                        <el-row v-else>暂无数据</el-row>
                                    </div>
                                    <span slot="reference">
                                        <i class="el-icon-my-xinxi color-primary"></i>
                                    </span>
                                </el-popover>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="评分"
                                prop="score"
                                :show-overflow-tooltip="true"
                                align="center"
                                :formatter="tableColumnFormatter"
                                min-width="50">
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center"
                                class-name="no-wrap"
                                min-width="150">
                            <template slot-scope="scope">
                                <el-dropdown class="mr-10" @command="handleCommand" :hide-on-click="false">
                                    <span class="el-dropdown-link">笔试评估</span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item :command="`${scope.row.id}/pass`">
                                            <i class="el-icon-my-queding color-success mr-10"></i>通过
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/undetermined`">
                                            <i class="el-icon-my-daiding color-warning mr-10"></i>待定
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/notPass`">
                                            <i class="el-icon-my-guanbi color-danger mr-10"></i>淘汰
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/lh`">
                                            <i class="el-icon-my-lahei color-purple mr-10"></i>拉黑
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/back`">
                                            <i class="el-icon-my-huitui color-info mr-10"></i>回退
                                        </el-dropdown-item>
                                        <el-dropdown-item :command="`${scope.row.id}/fq`"><i
                                                class="el-icon-my-guanbi color-danger mr-10"></i>放弃
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <router-link :to="`/written/recommend/${scope.row.id}`">
                                    <el-button type="text">笔试推荐</el-button>
                                </router-link>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" :show-overflow-tooltip="true" label="备注"
                                         align="center"
                                         min-width="120">
                            <template slot-scope="scope">
                                <remark-edit :id="scope.row.resumeId" v-model="scope.row.resumeRemark"></remark-edit>
                            </template>
                        </el-table-column>
                        <el-table-column prop="resumeForm.remark" :show-overflow-tooltip="true" label="最近操作人"
                                         align="center"
                                         min-width="120">
                            <template slot-scope="scope">
                                <div style="font-size: 12px;">
                                    <p>{{scope.row.lastOperateUserName}}</p>
                                    <p>{{scope.row.lastOperateTime && scope.row.lastOperateTime.slice(5)}}</p>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination
                        v-if="lists.length"
                        class="text-center mt-20 mb-20"
                        @size-change="pageSizeChange"
                        @current-change="pageIndexChange"
                        :current-page="pagination.pageIndex"
                        :page-size="pagination.pageSize"
                        :page-sizes="[20, 50, 100, 200]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pagination.recordCounts">
                </el-pagination>
            </div>
            <multi-remark-edit-dialog ref="multiRemarkEditDialog" @reload="fetchData"></multi-remark-edit-dialog>
        </div>
    </div>
</template>
<script type="text/javascript">
    import QueryListExtend from 'components/queryListExtend'
    import selectMapMixin from 'mixins/selectMapMixin'
    import RemarkEdit from '../operation/remarkEditDialog.vue'
    import MultiRemarkEditDialog from '../operation/multiRemarkEditDialog.vue'
    import operationMixin from '../operation/operationMixin'
    import queryListMixin from '../operation/queryListMixin'
    import StatusIcon from 'components/statusIcon'
    import { dateFormat } from 'modules/tools'
    import MultiSearch from 'views/common/multiSearch'

    export default {
        components: {
            StatusIcon, RemarkEdit, MultiSearch, MultiRemarkEditDialog
        },
        'extends': QueryListExtend,
        'mixins': [selectMapMixin, operationMixin, queryListMixin],
        data () {
            return {
                fetchUrl: '/arrangeExam/list.api',
                multiFields: [{
                    filter: 'WB_RESUME_STATUS_1',
                    label: '简历状态',
                    data: [],
                    mode: 'select',
                    name: 'resumeStatus'
                }, {
                    filter: 'WB_RESUME_EXAM_STATUS',
                    label: '考试状态',
                    data: [],
                    mode: 'select',
                    name: 'examStatus'
                }, {
                    filter: '',
                    label: '安排时间',
                    data: [],
                    mode: 'date',
                    name: 'arrangeTime'
                }, {
                    filter: '',
                    label: '开始时间',
                    data: [],
                    mode: 'date',
                    name: 'startTime'
                }],
                oneScoreList: []
            }
        },
        methods: {
            multiRemarkEdit(ids) {
                if (this.checkDataValid(ids)) {
                    let $target = this.$refs.multiRemarkEditDialog
                    let rids = this.lists
                        .filter(cv => {
                            return ids.indexOf(cv.id) > -1
                        })
                        .map(cv => {
                            return cv.resumeId
                        })
                        .join(',')
                    $target && $target.show(rids)
                }
            },
            dateFormat (date, format = 'yyyy/MM/dd') {
                return dateFormat(date, format)
            },
            multiProcess (routeName) {
                if (!this.checkDataValid(this.idStr)) {
                    return false
                }
                this.$router.push({name: routeName, params: {ids: this.idStr}})
            },
            hideTooltip (curItem) {
                if (this.ajax) {
                    this.source.cancel('取消未返回的请求')
                } else {
                    this.$set(curItem, 'isExamStatusShow', false)
                    this.$nextTick(() => {
                        const doms = document.querySelectorAll('.tooltip-status-popover')
                        doms.forEach(item => {
                            item.remove()
                        })
                    })
                }
            },
            changeArrangeTime (value) {
                this.searchData.arrangeTime = value
            },
            changeStartTime (value) {
                this.searchData.startTime = value
            },
            tableColumnFormatter (row, column, value) {
                return value || '-'
            },
            searchScore (curItem) {
                var rpid = curItem.id
                if (this.ajax) {
                    this.source.cancel('取消未返回的请求')
                }
                let CancelToken = this.$axios.CancelToken
                this.source = CancelToken.source()
                this.oneScoreList = []
                this.ajax = this.$axios.get('/arrangeExam/getPaperScore.api?id=' + rpid, {
                    cancelToken: this.source.token
                }).then(res => {
                    this.ajax = null
                    this.oneScoreList = res.result.list
                    this.showTips(curItem)
                })
            },
            showTips (curItem) {
                this.lists.map(item => {
                    item.isExamStatusShow === true && this.$set(item, 'isExamStatusShow', false)
                })
                this.$set(curItem, 'isExamStatusShow', true)
                this.$nextTick(() => {
                    const doms = document.querySelectorAll('.tooltip-status-popover')
                    doms.forEach((item, index) => {
                        (index !== doms.length - 1) && item.remove()
                    })
                })
            },
            toResumeDetail (row) {
                let path = '/resume/detail/' + row.id + '/' + row.resumeStatus.substr(0, 1)

                let routeData = this.$router.resolve({ path })
                window.open(routeData.href, '_blank')
            }
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";

    .dark-theme {
        background    : #1f2d3d;
        color         : #fff;
        border-radius : $border-radius;
        &[x-placement^="top"] .popper__arrow::after {
            border-top-color : #1f2d3d;
        }
    }

    .popper-line {
        .el-row {
            word-break : break-all;
            padding    : 3px 0;
            &:not(:first-child) {
                border-top : 1px solid #415062;
                margin-top : 1px;
            }
        }
    }

    .exam-name-span{
        max-width: 95px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        vertical-align: bottom;
    }
</style>



// WEBPACK FOOTER //
// writtenList.vue?12f012d4